<template>
  <div
    class="kd-text-layer-settings"
    v-if="ACTIVE_LAYER"
    >
    <div class="kd-layer-settings-unit">
      <div class="kd-layer-settings-unit__headline">Schriftfarbe</div>
      <kd-font-color-switcher
        :items="THEME_FONT_COLORS"
        :initial="color"
      ></kd-font-color-switcher>
    </div>
    <div class="kd-layer-settings-unit">
      <div class="kd-layer-settings-unit__headline">
        Schriftgröße
      <input
        type="number"
        class="kd-layer-settings-unit__number-input"
        :value="fontSize"
        @input="fontSizeChanged($event.target.value)"
      />
      </div>
      <kd-range-slider
        class="kd-layer-settings-unit__slider"
        :initial-value="fontSize"
        :step="1"
        :min="minFontSize"
        :max="maxFontSize"
        @change="fontSizeChanged"
      ></kd-range-slider>
    </div>
    <div class="kd-layer-settings-unit">
      <div class="kd-layer-settings-unit__headline">Schriftart</div>
      <!-- <select
        style="width: 100%"
        class="kd-text-layer-settings__font-select"
        @change="fontChanged"
        v-model="fontName"
      >
        <option
          v-for="webfont in webfonts"
          :key="webfont.name"
          :value="webfont.name"
        >
        {{ webfont.name }}
        </option>
      </select> -->

      <kd-font-select
        :options="webfonts"
        :selected="fontName"
        @change="fontChanged"
        style="margin-bottom: 12px;"
      ></kd-font-select>


      <div class="kd-font-style-buttons">
        <icon-toggle-button
          style="margin-right: 10px;"
          trueValue="700"
          falseValue="400"
          :iconTrueUrl="require('../assets/images/icons/text-bold-white.svg')"
          :iconFalseUrl="require('../assets/images/icons/text-bold.svg')"
          :initial-value="fontWeight === '700'"
          @change="fontWeightChanged"
        ></icon-toggle-button>
        <icon-toggle-button
          trueValue="italic"
          falseValue="normal"
          :iconTrueUrl="require('../assets/images/icons/text-italic-white.svg')"
          :iconFalseUrl="require('../assets/images/icons/text-italic.svg')"
          :initial-value="fontStyle === 'italic'"
          @change="fontStyleChanged"
        ></icon-toggle-button>
      </div>
    </div>
    <div class="kd-layer-settings-unit">
      <div class="kd-layer-settings-unit__headline">
        Zeilenabstand
      <input
        type="number"
        step="0.1"
        class="kd-layer-settings-unit__number-input"
        :value="lineHeight"
        @input="lineHeightChanged($event.target.value)"
      />
      </div>
      <kd-range-slider
        class="kd-layer-settings-unit__slider"
        :initial-value="lineHeight"
        :step="0.1"
        :min="minLineHeight"
        :max="maxLineHeight"
        @change="lineHeightChanged"
      ></kd-range-slider>
    </div>
    <div class="kd-layer-settings-unit">
      <div class="kd-layer-settings-unit__headline">Ausrichtung</div>
      <kd-text-alignment
        :alignment-x= "initialAlignmentX"
        :alignment-y= "initialAlignmentY"
      ></kd-text-alignment>
    </div>
    <div
      class="kd-layer-settings-unit"
      style="margin-bottom: 18px"
    >
      <kd-button-medium
        text="Textstil zurücksetzen"
        @click.native="resetTextStyles"
      ></kd-button-medium>
    </div>
  </div>
</template>

<script>
import * as log from 'loglevel';
import { mapGetters, mapMutations } from 'vuex';

import KdRangeSlider from '@/components/KdRangeSlider.vue';
import IconToggleButton from '@/components/IconToggleButton.vue';
import KdFontColorSwitcher from '@/components/KdFontColorSwitcher.vue';
import KdTextAlignment from '@/components/KdTextAlignment.vue';
import KdButtonMedium from '@/components/KdButtonMedium.vue';
import KdFontSelect from '@/components/KdFontSelect.vue';

import webfonts from '@/shared/webfonts';
import directions from '@/shared/directions';

import {
  ACTIVE_LAYER,
  THEME_FONT_COLORS,
} from '@/store/getter-types';

import {
  SET_FONT_NAME_FOR_ACTIVE_LAYER,
  SET_FONT_WEIGHT_FOR_ACTIVE_LAYER,
  SET_FONT_STYLE_FOR_ACTIVE_LAYER,
  RESET_TEXT_LAYER_STYLES,
} from '@/store/mutation-types';

import {
  SET_FONT_SIZE,
  SET_LINE_HEIGHT,
} from '@/store/action-types';

export default {
  computed: {
    ...mapGetters([
      ACTIVE_LAYER,
      THEME_FONT_COLORS,
    ]),
    initialFontSize() {
      if (this.ACTIVE_LAYER && this.ACTIVE_LAYER.fontSize) {
        return this.ACTIVE_LAYER.fontSize;
      }
      return 20;
    },
    initialFontName() {
      if (this.ACTIVE_LAYER && this.ACTIVE_LAYER.fontName) {
        return this.ACTIVE_LAYER.fontName;
      }
      return 'sans-serif';
    },
    initialFontWeight() {
      if (this.ACTIVE_LAYER && this.ACTIVE_LAYER.fontWeight) {
        return this.ACTIVE_LAYER.fontWeight;
      }
      return 400;
    },
    initialFontStyle() {
      if (this.ACTIVE_LAYER && this.ACTIVE_LAYER.fontStyle) {
        return this.ACTIVE_LAYER.fontStyle;
      }
      return 'normal';
    },
    initialLineHeight() {
      if (this.ACTIVE_LAYER && this.ACTIVE_LAYER.lineHeight) {
        return this.ACTIVE_LAYER.lineHeight;
      }
      return 1.2; // TODO: This must match Templatedesigner default
    },
    initialColor() {
      if (this.ACTIVE_LAYER && this.ACTIVE_LAYER.color) {
        return this.ACTIVE_LAYER.color;
      }
      return '#000000';
    },
    // TODO: Extract default to standards file
    initialAlignmentX() {
      if (this.ACTIVE_LAYER && this.ACTIVE_LAYER.alignmentX) {
        return this.ACTIVE_LAYER.alignmentX;
      }
      return directions.LEFT;
    },
    // TODO: Extract default to standards file
    initialAlignmentY() {
      if (this.ACTIVE_LAYER && this.ACTIVE_LAYER.alignmentY) {
        return this.ACTIVE_LAYER.alignmentY;
      }
      return directions.LEFT;
    },
    webfonts() { return webfonts; },
    // initialFontColors() { return this.THEME_FONT_COLORS; },
  },
  data() {
    return {
      fontSize: 1,
      minFontSize: 8,
      maxFontSize: 120, // TODO: Check if this is big enough for big headlines
      fontWeight: '400',
      fontStyle: 'normal',
      fontColors: [],
      fontName: '',
      lineHeight: 1.2, // TODO: This must match Templatedesigner default
      minLineHeight: 0.4,
      maxLineHeight: 3,
      color: '#000',
    };
  },
  methods: {
    ...mapMutations([
      RESET_TEXT_LAYER_STYLES,
    ]),
    fullUrl(url) { return process.env.VUE_APP_IMAGE_SERVER + url},
    updateValues() {
      this.fontSize = this.initialFontSize;
      this.lineHeight = this.initialLineHeight;
      this.fontName = this.initialFontName;
      this.fontWeight = this.initialFontWeight;
      // this.fontColors = this.initialFontColors ? this.initialFontColors.slice() : [];
      this.fontColors = [];
      // this.initialFontColors.forEach(color => this.fontColors.push(color));
      this.fontStyle = this.initialFontStyle;
      this.color = this.initialColor;
    },
    fontSizeChanged(value) {
      this.$store.dispatch(SET_FONT_SIZE, +value);
    },
    lineHeightChanged(value) {
      this.$store.dispatch(SET_LINE_HEIGHT, +value);
    },
    fontWeightChanged(weight) {
      this.fontWeight = weight;
      this.$store.commit(SET_FONT_WEIGHT_FOR_ACTIVE_LAYER, weight);
    },
    fontStyleChanged(style) {
      this.fontStyle = style;
      this.$store.commit(SET_FONT_STYLE_FOR_ACTIVE_LAYER, style);
    },
    // fontChanged(ev) {
    //   const fontName = ev.target.value;
    //   this.$store.commit(SET_FONT_NAME_FOR_ACTIVE_LAYER, fontName);
    // },
    fontChanged(fontName) {
      this.$store.commit(SET_FONT_NAME_FOR_ACTIVE_LAYER, fontName);
    },
    resetTextStyles() {
      this.RESET_TEXT_LAYER_STYLES();
    },
  },
  watch: {
    initialFontSize() {
      this.fontSize = this.ACTIVE_LAYER.fontSize;
    },
    initialLineHeight() {
      this.lineHeight = this.ACTIVE_LAYER.lineHeight;
    },
    initialFontName() {
      this.fontName = this.ACTIVE_LAYER.fontName;
    },
    initialFontWeight() {
      this.fontWeight = this.ACTIVE_LAYER.fontWeight;
    },
    initialFontStyle() {
      this.fontStyle = this.ACTIVE_LAYER.fontStyle;
    },
    initialFontColors(fontColorsNew) {
      this.fontColors = fontColorsNew ? fontColorsNew.slice() : [];
    },
    initialColor() {
      this.color = this.ACTIVE_LAYER.color;
    },
  },
  mounted() { this.updateValues(); },
  updated() { this.updateValues(); },
  components: {
    KdRangeSlider,
    IconToggleButton,
    KdFontColorSwitcher,
    KdTextAlignment,
    KdButtonMedium,
    KdFontSelect,
  },
};
</script>

<style lang="scss">
@import '@/scss/kd-layer-settings-unit.scss';

.kd-text-layer-settings__font-select {
  margin-bottom: 14px;
}

.kd-font-style-buttons {
  display: flex;
}

.kd-layer-settings-unit__number-input {
  position: relative;
  top: -3px; // optically align with label on the left
  width: 44px;
  float: right;
  border: none;
  text-align: right;
  border: 1px solid #ededed;
  border-radius: 3px;

  &:after {
    clear: both;
  }
}
</style>
